import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from '../locales/fr.json';

const resources = {
  fr: {
    translation: fr
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    
    interpolation: {
      escapeValue: false,
    },
    
    debug: process.env.NODE_ENV === 'development',
  });

export default i18n; 